import React, { useEffect } from "react";
import { Grid, MenuItem, Card } from "@mui/material";
import { useFormikContext } from "formik";
import MDBox from "components/MDBox";
import FormField from "components/FormField";
import { useGetTagsQuery } from "services";
import useModalHandler from "hooks/useModalHandler";
import ModalCarpetaCursos from "components/ModalCarpetasCursos/new-carpeta-cursos";
import { useDispatch, useSelector } from "react-redux";
import { cursos_slice, setNuevaCarpeta, setCreadaNew } from "slices";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

const CarpetaSelect = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { values, errors, touched, handleChange, setFieldValue } =
    useFormikContext();

  const {
    open: openCarpeta,
    handleOpen: handleOpenCarpeta,
    handleClose: handleCloseCarpeta,
  } = useModalHandler();

  const { data: carpetas } = useGetTagsQuery();
  const { creadaNew } = useSelector(cursos_slice);
  const dispatch = useDispatch();

  useEffect(() => {
    if (creadaNew && carpetas?.length > 0) {
      setFieldValue("tags", creadaNew);
    }
    return () => {
      dispatch(setNuevaCarpeta(""));
      dispatch(setCreadaNew(""));
    };
  }, [creadaNew, carpetas, dispatch, setFieldValue]);

  return (
    <MDBox mb={3}>
      <ModalCarpetaCursos open={openCarpeta} handleClose={handleCloseCarpeta} />

      <MDTypography variant="h6" color={darkMode ? "white" : "dark"} mb={2}>
        Organización
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormField
            select
            label="Carpeta (Tags)"
            name="tags"
            value={values.tags}
            onChange={handleChange}
            error={errors.tags && touched.tags}
            helperText="Selecciona o crea una carpeta para organizar este título"
          >
            <MenuItem value="">
              <em>Ninguna</em>
            </MenuItem>
            {carpetas?.map((el) => (
              <MenuItem key={el.id} value={el.url}>
                {el.nombre}
              </MenuItem>
            ))}
            <MenuItem value="new" onClick={handleOpenCarpeta}>
              + Crear nueva carpeta
            </MenuItem>
          </FormField>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default CarpetaSelect;
